"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllPromptHistory = getAllPromptHistory;
exports.createPromptHistory = createPromptHistory;
exports.updatePromptHistory = updatePromptHistory;
const apiFetch_1 = require("../utils/apiFetch");
const API_BASE = process.env.WITHOUT_GATEWAY ? process.env.REACT_APP_TEMPLATE_BUILDER_URL : `${process.env.REACT_APP_API_BASE_URL}/v1/template-builder`;
function getAllPromptHistory(sessionId) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, apiFetch_1.apiFetch)(`${API_BASE}/prompt-history?sessionId=${sessionId}`);
    });
}
function createPromptHistory(sessionId, prompt, aiResponseHtml) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, apiFetch_1.apiFetch)(`${API_BASE}/prompt-history`, {
            method: 'POST',
            body: JSON.stringify({ sessionId: parseInt(sessionId.toString()), prompt, aiResponseHtml })
        });
    });
}
function updatePromptHistory(id, aiResponseHtml) {
    return __awaiter(this, void 0, void 0, function* () {
        return (0, apiFetch_1.apiFetch)(`${API_BASE}/prompt-history/${id}`, {
            method: 'PATCH',
            body: JSON.stringify({ aiResponseHtml })
        });
    });
}
